import { useTheme } from '@material-ui/core/styles';

const LogoFull = () => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <img
      src="/Kyndryl_Logo.png"
      alt="Kyndryl"
      style={{
        height: 22,
        width: 'auto',
        filter: isDark ? 'brightness(0) invert(1)' : 'none',
      }}
    />
  );
};

export default LogoFull;
